import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _acceptOrderRequest = {
    pickupTime: 'google.protobuf.Timestamp',
    dropOffTime: 'google.protobuf.Timestamp',
};
var _acceptOrderResponse = { order: '_order' };
var _activity = { timestamp: 'google.protobuf.Timestamp' };
var _cancelOrderRequest = {};
var _cancelOrderResponse = { order: '_order' };
var _countOrdersQuery = { promisedTime: '_dateRangeFilter' };
var _countOrdersRequest = { query: '_countOrdersQuery' };
var _countOrdersResponse = {};
var _dateRangeFilter = {
    startTime: 'google.protobuf.Timestamp',
    endTime: 'google.protobuf.Timestamp',
};
var _deliveryAddress = { location: '_deliveryAddressLocation' };
var _deliveryAddressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _deliveryDetails = {
    externalProvider: '_externalProvider',
    address: '_deliveryAddress',
    pickupInfo: '_pickupInfo',
    dropOffInfo: '_dropOffInfo',
};
var _dropOffInfo = {
    windowStartTime: 'google.protobuf.Timestamp',
    windowEndTime: 'google.protobuf.Timestamp',
};
var _externalProvider = {
    pickupTime: 'google.protobuf.Timestamp',
    dropOffTime: 'google.protobuf.Timestamp',
};
var _fulfillment = {
    promisedTime: 'google.protobuf.Timestamp',
    deliveryDetails: '_deliveryDetails',
};
var _fulfillOrderRequest = {};
var _fulfillOrderResponse = { order: '_order' };
var _getOrderByMsidRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _getOrderByMsidResponse = { order: '_order' };
var _getOrderRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _getOrderResponse = { order: '_order' };
var _getTotalActiveOrdersRequest = {};
var _getTotalActiveOrdersResponse = {};
var _lineItem = { dishOptions: '_lineItemOption' };
var _lineItemOption = { selectedChoices: '_lineItem' };
var _listOrdersByMsidRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _listOrdersByMsidResponse = { orders: '_order' };
var _listOrdersRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _listOrdersResponse = { orders: '_order' };
var _notifyOrderEventRequest = {};
var _notifyOrderEventResponse = {};
var _order = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lineItems: '_lineItem',
    fulfillment: '_fulfillment',
    activities: '_activity',
};
var _pickupInfo = {
    windowStartTime: 'google.protobuf.Timestamp',
    windowEndTime: 'google.protobuf.Timestamp',
};
function resolveComWixpressRestaurantsOrdersV3OrdersBackOfficeApiUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v3/admin/orders/notify-order-event',
                destPath: '/v3/admin/orders/notify-order-event',
            },
            {
                srcPath: '/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressRestaurantsOrdersV3OrdersApiUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v3/admin/orders/notify-order-event',
                destPath: '/v3/admin/orders/notify-order-event',
            },
            {
                srcPath: '/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants/v3/orders',
                destPath: '/v3/orders',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressRestaurantsOrdersBmRestaurantsOrdersBmUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v3/orders-bm/totals',
                destPath: '/v3/orders-bm/totals',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/restaurants/v3/orders-bm/totals',
                destPath: '/v3/orders-bm/totals',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** return list of orders total amount mapped to each location based on given status. */
export function getTotalActiveOrders(payload) {
    var _a = serializer(_getTotalActiveOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTotalActiveOrdersResponse, {}).fromJSON;
    function __getTotalActiveOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.orders.bm.RestaurantsOrdersBm.GetTotalActiveOrders',
            url: resolveComWixpressRestaurantsOrdersBmRestaurantsOrdersBmUrl({
                protoPath: '/v3/orders-bm/totals',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTotalActiveOrders.fromReq = fromReq;
    __getTotalActiveOrders.__isAmbassador = true;
    return __getTotalActiveOrders;
}
/** Retrieves an order. */
export function getOrder(payload) {
    var _a = serializer(_getOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderResponse, {
        _activity: _activity,
        _deliveryAddress: _deliveryAddress,
        _deliveryAddressLocation: _deliveryAddressLocation,
        _deliveryDetails: _deliveryDetails,
        _dropOffInfo: _dropOffInfo,
        _externalProvider: _externalProvider,
        _fulfillment: _fulfillment,
        _lineItem: _lineItem,
        _lineItemOption: _lineItemOption,
        _order: _order,
        _pickupInfo: _pickupInfo,
    }).fromJSON;
    function __getOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.orders.v3.OrdersApi.GetOrder',
            url: resolveComWixpressRestaurantsOrdersV3OrdersApiUrl({
                protoPath: '/v3/orders/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrder.fromReq = fromReq;
    __getOrder.__isAmbassador = true;
    return __getOrder;
}
/** Retrieves a list of up to 1000 orders, given the provided filters. */
export function listOrders(payload) {
    var _a = serializer(_listOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOrdersResponse, {
        _activity: _activity,
        _deliveryAddress: _deliveryAddress,
        _deliveryAddressLocation: _deliveryAddressLocation,
        _deliveryDetails: _deliveryDetails,
        _dropOffInfo: _dropOffInfo,
        _externalProvider: _externalProvider,
        _fulfillment: _fulfillment,
        _lineItem: _lineItem,
        _lineItemOption: _lineItemOption,
        _order: _order,
        _pickupInfo: _pickupInfo,
    }).fromJSON;
    function __listOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.orders.v3.OrdersApi.ListOrders',
            url: resolveComWixpressRestaurantsOrdersV3OrdersApiUrl({
                protoPath: '/v3/orders',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOrders.fromReq = fromReq;
    __listOrders.__isAmbassador = true;
    return __listOrders;
}
/**
 * Changes the order status to `ACCEPTED`.
 *
 * > **Note:** It is not possible to change the order status from `FULFILLED` to `ACCEPTED`.
 */
export function acceptOrder(payload) {
    var _a = serializer(_acceptOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_acceptOrderResponse, {
        _activity: _activity,
        _deliveryAddress: _deliveryAddress,
        _deliveryAddressLocation: _deliveryAddressLocation,
        _deliveryDetails: _deliveryDetails,
        _dropOffInfo: _dropOffInfo,
        _externalProvider: _externalProvider,
        _fulfillment: _fulfillment,
        _lineItem: _lineItem,
        _lineItemOption: _lineItemOption,
        _order: _order,
        _pickupInfo: _pickupInfo,
    }).fromJSON;
    function __acceptOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.orders.v3.OrdersApi.AcceptOrder',
            url: resolveComWixpressRestaurantsOrdersV3OrdersApiUrl({
                protoPath: '/v3/orders/{id}/accept',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __acceptOrder.fromReq = fromReq;
    __acceptOrder.__isAmbassador = true;
    return __acceptOrder;
}
/** Changes the order status to `CANCELED`. */
export function cancelOrder(payload) {
    var _a = serializer(_cancelOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelOrderResponse, {
        _activity: _activity,
        _deliveryAddress: _deliveryAddress,
        _deliveryAddressLocation: _deliveryAddressLocation,
        _deliveryDetails: _deliveryDetails,
        _dropOffInfo: _dropOffInfo,
        _externalProvider: _externalProvider,
        _fulfillment: _fulfillment,
        _lineItem: _lineItem,
        _lineItemOption: _lineItemOption,
        _order: _order,
        _pickupInfo: _pickupInfo,
    }).fromJSON;
    function __cancelOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.orders.v3.OrdersApi.CancelOrder',
            url: resolveComWixpressRestaurantsOrdersV3OrdersApiUrl({
                protoPath: '/v3/orders/{id}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelOrder.fromReq = fromReq;
    __cancelOrder.__isAmbassador = true;
    return __cancelOrder;
}
/** Changes the order status to `FULFILLED`. */
export function fulfillOrder(payload) {
    var _a = serializer(_fulfillOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_fulfillOrderResponse, {
        _activity: _activity,
        _deliveryAddress: _deliveryAddress,
        _deliveryAddressLocation: _deliveryAddressLocation,
        _deliveryDetails: _deliveryDetails,
        _dropOffInfo: _dropOffInfo,
        _externalProvider: _externalProvider,
        _fulfillment: _fulfillment,
        _lineItem: _lineItem,
        _lineItemOption: _lineItemOption,
        _order: _order,
        _pickupInfo: _pickupInfo,
    }).fromJSON;
    function __fulfillOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.orders.v3.OrdersApi.FulfillOrder',
            url: resolveComWixpressRestaurantsOrdersV3OrdersApiUrl({
                protoPath: '/v3/orders/{id}/fulfill',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __fulfillOrder.fromReq = fromReq;
    __fulfillOrder.__isAmbassador = true;
    return __fulfillOrder;
}
/** Returns the number of orders that match the query. */
export function countOrders(payload) {
    var _a = serializer(_countOrdersRequest, {
        _countOrdersQuery: _countOrdersQuery,
        _dateRangeFilter: _dateRangeFilter,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countOrdersResponse, {}).fromJSON;
    function __countOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.orders.v3.OrdersApi.CountOrders',
            url: resolveComWixpressRestaurantsOrdersV3OrdersApiUrl({
                protoPath: '/v3/orders/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countOrders.fromReq = fromReq;
    __countOrders.__isAmbassador = true;
    return __countOrders;
}
/** Retrieves an order. */
export function getOrderByMsid(payload) {
    var _a = serializer(_getOrderByMsidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderByMsidResponse, {
        _activity: _activity,
        _deliveryAddress: _deliveryAddress,
        _deliveryAddressLocation: _deliveryAddressLocation,
        _deliveryDetails: _deliveryDetails,
        _dropOffInfo: _dropOffInfo,
        _externalProvider: _externalProvider,
        _fulfillment: _fulfillment,
        _lineItem: _lineItem,
        _lineItemOption: _lineItemOption,
        _order: _order,
        _pickupInfo: _pickupInfo,
    }).fromJSON;
    function __getOrderByMsid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.orders.v3.OrdersBackOfficeApi.GetOrderByMsid',
            url: resolveComWixpressRestaurantsOrdersV3OrdersBackOfficeApiUrl({
                protoPath: '/v3/admin/orders/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrderByMsid.fromReq = fromReq;
    __getOrderByMsid.__isAmbassador = true;
    return __getOrderByMsid;
}
/** Retrieves a list of up to 2000 orders, given the provided filters. */
export function listOrdersByMsid(payload) {
    var _a = serializer(_listOrdersByMsidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOrdersByMsidResponse, {
        _activity: _activity,
        _deliveryAddress: _deliveryAddress,
        _deliveryAddressLocation: _deliveryAddressLocation,
        _deliveryDetails: _deliveryDetails,
        _dropOffInfo: _dropOffInfo,
        _externalProvider: _externalProvider,
        _fulfillment: _fulfillment,
        _lineItem: _lineItem,
        _lineItemOption: _lineItemOption,
        _order: _order,
        _pickupInfo: _pickupInfo,
    }).fromJSON;
    function __listOrdersByMsid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.orders.v3.OrdersBackOfficeApi.ListOrdersByMsid',
            url: resolveComWixpressRestaurantsOrdersV3OrdersBackOfficeApiUrl({
                protoPath: '/v3/admin/orders',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOrdersByMsid.fromReq = fromReq;
    __listOrdersByMsid.__isAmbassador = true;
    return __listOrdersByMsid;
}
export function notifyOrderEvent(payload) {
    var _a = serializer(_notifyOrderEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_notifyOrderEventResponse, {}).fromJSON;
    function __notifyOrderEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v3.order',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.orders.v3.OrdersBackOfficeApi.NotifyOrderEvent',
            url: resolveComWixpressRestaurantsOrdersV3OrdersBackOfficeApiUrl({
                protoPath: '/v3/admin/orders/notify-order-event',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __notifyOrderEvent.fromReq = fromReq;
    __notifyOrderEvent.__isAmbassador = true;
    return __notifyOrderEvent;
}
//# sourceMappingURL=http.impl.js.map